module.exports = __webpack_public_path__ + "e8c750a40fa2d1204842154d833d9a13.png";